import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { CollectionPage } from "@/features/collection/components/collection-page";
import { useI18n } from "@/providers/i18n-provider";

function CollectionRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Tu colección`)}
      description={t(msg`Inicia sesión para guardar tus figuras y seguir tu progreso por serie.`)}
    >
      <CollectionPage />
    </AuthPlaceholder>
  );
}

export const collectionRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/collection",
  component: CollectionRoutePage,
});
